import { appMenuItems } from "app/components/molecules/navbar/model/commonMenuData";

export const MEMBERSHIP_TYPE_MAP = {
  1: "Corporate Member",
  2: "Associate Member",
  3: "Student",
  4: "Fellow",
  5: "Participant",
  6: "Honorary Fellow",
};

const MENTORING_DESCRIPTION = "Please select your role: Mentor or Mentee. Only one option may be chosen. Please keep your availability status up to date. Switch it off if you are no longer seeking mentorship or, in the case of mentors, once you have reached capacity.";

const SAICE_CONNECT_TILE = {
  title: "SAICE Connect",
  groupedLinks: [
    {
      heading: "Mentor",
      links: [
        {
          name: "Manage Availability",
          link: "/saice-connect/mentoring/manage-availability",
        },
        {
          name: "Review Mentoring Matches",
          link: "/saice-connect/mentoring/review-requests",
        },
      ],
    },
    {
      heading: "Mentee",
      links: [
        {
          name: "Manage Availability",
          link: "/saice-connect/mentorship/manage-availability",
        },
        // {
        //   name: "Request Mentorship",
        //   link: "/saice-connect/mentorship/request-mentorship",
        // },
      ],
    },
    {
      heading: "Employment",
      description: "If you are seeking employment please ensure an updated version of your CV is uploaded to your profile. SAICE will forward this document to potential employers once a profile request is approved.",
      links: [
        {
          name: "Upload your CV",
          link: "/profile/upload-cv",
        },
        {
          name: "Opt-In to Employer Search",
          link: "/saice-connect/employment/opt-in-to-employer-search",
        },
        {
          name: "View Profile Requests",
          link: "/saice-connect/employment/view-profile-requests",
        },
      ],
    },
  ],
};

export const getHomeTilesData = (serviceRequests = [], contactDetails = {}) => {
  // Filter groupedLinks based on mentor/mentee status
  const filteredGroupedLinks = SAICE_CONNECT_TILE.groupedLinks.filter((group) => {
    // Always show Employment group
    if (group.heading === "Employment") {
      return true;
    }
    
    // Show Mentor links if user is NOT a mentee (ctpt_connectmentee is "False" or falsy)
    if (group.heading === "Mentor") {
      const isMentee = contactDetails.ctpt_connectmentee;
      // API returns "True" or "False" as strings, show Mentor group if NOT "True"
      return isMentee !== "True" && isMentee !== true;
    }
    
    // Show Mentee links if user is NOT a mentor (ctpt_connectmentor is "False" or falsy)
    if (group.heading === "Mentee") {
      const isMentor = contactDetails.ctpt_connectmentor;
      // API returns "True" or "False" as strings, show Mentee group if NOT "True"
      return isMentor !== "True" && isMentor !== true;
    }
    
    return true;
  });

  // Determine which mentor/mentee groups are visible
  const mentorGroup = filteredGroupedLinks.find(group => group.heading === "Mentor");
  const menteeGroup = filteredGroupedLinks.find(group => group.heading === "Mentee");
  const hasMentor = !!mentorGroup;
  const hasMentee = !!menteeGroup;

  // Map over filtered groups and add description to the appropriate group based on visibility
  // Priority: If both visible → Mentor, if only one visible → that one
  const groupedLinksWithDescription = filteredGroupedLinks.map((group) => {
    // Skip non-mentor/mentee groups (like Employment)
    if (group.heading !== "Mentor" && group.heading !== "Mentee") {
      return {
        ...group,
      description: SAICE_CONNECT_TILE.groupedLinks[2].description

      };
    }
    
    // Determine if this group should have the description
    // If Mentor exists, add to Mentor (handles both "only Mentor" and "both" cases)
    // If only Mentee exists (no Mentor), add to Mentee
    const shouldAddDescription = 
      (group.heading === "Mentor" && hasMentor) || 
      (group.heading === "Mentee" && hasMentee && !hasMentor);
    
    if (shouldAddDescription) {
      // Create a new object with the description added, preserving all existing properties
      return {
        ...group,
        description: MENTORING_DESCRIPTION,
      };
    }
    
    // Return the group as-is if no description should be added
    return group;
  });

  const saiceConnectTile = {
    ...SAICE_CONNECT_TILE,
    groupedLinks: groupedLinksWithDescription,
  };

  return [
    {
      title: "Your applications",
      items: appMenuItems[0].items,
    },
    {
      title: "Membership",
      items: appMenuItems[1].items,
    },
    {
      title: "Invoice & Payments",
      items: appMenuItems[2].items,
    },
    {
      title: "Service Requests",
      items: [...appMenuItems[3].items, ...serviceRequests],
    },
    {
      title: "Personal details",
      items: appMenuItems[4].items,
    },
    saiceConnectTile,
    // {
    //   title: "CPD",
    //   items: appMenuItems[4].items,
    // },
  ];
};

export const CARDS_DATA = [
  // {
  //   id: "1",
  //   title: "SAICE Academy",
  //   description:
  //     "Grow your professional development by viewing and booking the latest SAICE courses on offer",
  //   backgroundColor: "#1b9dd9",
  //   backgroundImageURL: "/brand/ellipse-light-blue.png",
  //   textColor: "white",
  //   linkUrl: "https://store.saice.org.za/courses",
  //   buttonText: "BROWSE CATALOGUE",
  // },
  // {
  //   id: "2",
  //   title: "Membership Subscription Fees",
  //   description: "Membership subscription and division fees",
  //   backgroundColor: "#BAA35F",
  //   textColor: "white",
  //   buttonText: "Know more",
  //   linkUrl: "https://saice.org.za/saice-membership-fees/",
  //   backgroundImageURL: "/brand/ellipse-gold.png",
  // },
  // {
  //   id: "3",
  //   title: "SAICE Membership Benefits",
  //   description:
  //     "Browse the range of opportunities and benefits of being a SAICE member.",
  //   backgroundColor: "#3C3C3C",
  //   textColor: "white",
  //   buttonText: "Find out more",
  //   linkUrl: "https://saice.org.za/membership/",
  //   backgroundImageURL: "/brand/ellipse-grey.png",
  // },
  // {
  //   id: "4",
  //   title: "SAICE Membership Application",
  //   description: "Apply to become a member of SAICE today!",
  //   backgroundColor: "#001C30",
  //   textColor: "white",
  //   buttonText: "Apply Now",
  //   linkUrl: "https://apply.saice.org.za/",
  //   backgroundImageURL: "/brand/ellipse-copy.png",
  // },
  // {
  //   id: "5",
  //   title: "SAICE Bookstore",
  //   description:
  //     " SAICE offers a platform for members to avail the book store facility",
  //   backgroundColor: "#BAA35F",
  //   textColor: "white",
  //   buttonText: "Know More",
  //   linkUrl: "https://store.saice.org.za/book-store",
  //   backgroundImageURL: "/brand/ellipse-gold.png",
  // },
  // {
  //   id: "6",
  //   title: "Mentor Application",
  //   description: "Apply to become a Mentor!",
  //   backgroundColor: "#001C30",
  //   textColor: "white",
  //   buttonText: "Apply Now",
  //   linkUrl: "https://saice.xenon.co.za/connect.php?type=3",
  //   backgroundImageURL: "/brand/ellipse-copy.png",
  // },
  // {
  //   id: "7",
  //   title: "Mentee Application",
  //   description: "Apply if you require guidance and mentorship",
  //   backgroundColor: "#1b9dd9",
  //   textColor: "white",
  //   buttonText: "Apply Now",
  //   linkUrl: "https://saice.xenon.co.za/connect.php?type=2",
  //   backgroundImageURL: "/brand/ellipse-copy.png",
  // },
  // {
  //   id: "8",
  //   title: "Employment Opportunity",
  //   description: "Apply if you are seeking employment",
  //   backgroundColor: "#BAA35F",
  //   textColor: "white",
  //   buttonText: "Apply Now",
  //   linkUrl: "https://saice.xenon.co.za/connect.php?type=1",
  //   backgroundImageURL: "/brand/ellipse-copy.png",
  // },
];
